import { render, staticRenderFns } from "./picZoom.vue?vue&type=template&id=1082741e&scoped=true&"
import script from "./picZoom.vue?vue&type=script&lang=js&"
export * from "./picZoom.vue?vue&type=script&lang=js&"
import style0 from "./picZoom.vue?vue&type=style&index=0&id=1082741e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1082741e",
  null
  
)

export default component.exports